import { useState } from "react";
import { toast } from "sonner";
import { trpc } from "~/utils/trpc";

const POLL_INTERVAL_MS = 5000;
const MAX_ITERATIONS = 50;
export const usePaymentRecordPoll = () => {
  const utils = trpc.useUtils();
  const [status, setStatus] = useState<"IDLE" | "CLAIMING" | "QUEUED" | "PENDING" | "SUCCESS" | "FAILED" | "TIMEOUT">(
    "IDLE",
  );

  const pollPaymentStatus = async (paymentRecordId: string, iteration = 0) => {
    if (iteration > MAX_ITERATIONS) {
      setStatus("TIMEOUT");
      return;
    }
    const res = await utils.public.rewards.getPaymentRecord.fetch({ paymentRecordId });
    if (res?.status === "COMPLETED") {
      utils.public.rewards.getPaymentHistory.invalidate();
      utils.public.rewards.getClaimableRewards.invalidate();
      setStatus("SUCCESS");
      toast.success("Payment successful");
      return;
    }
    if (res?.status === "FAILED" || res?.status === "UNRESOLVED") {
      setStatus("FAILED");
      toast.error("Payment failed");
      return;
    }

    if (res?.status === "PENDING") {
      setStatus("PENDING");
    }

    if (res?.status === "QUEUED") {
      setStatus("QUEUED");
    }

    setTimeout(() => pollPaymentStatus(paymentRecordId, iteration + 1), POLL_INTERVAL_MS);
  };

  return {
    pollPaymentStatus,
    setStatus,
    status,
  };
};
